/** Keep two caption lines plus their gap below a headline in a short card. */
export function metricFigureHeightLimit(bodyHeight: number, hasComparison: boolean): number {
  const comparisonHeight = hasComparison ? 36 : 0;
  // Below 16px, keep the number readable and let the shell scroll if needed.
  return Math.max(16, Math.floor((bodyHeight - comparisonHeight) / 1.2));
}
